import { useEffect } from 'react'

import { mplusApi } from 'redux/services/mplus'
import { GetMplusParams } from 'redux/services/mplus/types'

import { AppStatistics } from 'components/AppStatistics/AppStatistics'

interface StatisticsProps {
  filters: GetMplusParams
}

export function Statistics({ filters }: StatisticsProps) {
  const [fetch, fetchState] = mplusApi.useLazyMplusStatisticsQuery()

  useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  if (fetchState.isSuccess) {
    return <AppStatistics list={fetchState.data} />
  }
  return null
}
